import moment from 'moment';
import buildDateFilter, { readDateFilterParams } from './buildDateFilter';

const buildAdvertiserWhere = ({ currentOrgId, params }) => {
  const search = params.get('search');
  const status = params.get('status');
  const advertiser = params.get('advertiser');

  let where = {
    AND: [{ status_not: 'DEMO' }, { impressionsTag: { id_not: null } }],
    OR: [
      { sharedOrgs_some: { org: { id: currentOrgId } } },
      { sharedOrgs_some: { org: { parentOrg_some: { id: currentOrgId } } } },
    ],
  };
  if (status === 'DEMO') {
    where = { AND: [{ status: 'DEMO' }] };
  }

  if (search) {
    where.AND.push({ name_contains: search });
  }

  if (advertiser) {
    where.AND.push({ impressionsTag: { orgs_some: { id: advertiser } } });
  }

  if (status) {
    const currentDate = moment().format();
    const attributionWindow = moment().subtract(30, 'days').format();
    if (status === 'PAUSED') {
      where.AND.push({ status });
    } else if (status === 'FINISHED') {
      where.AND = [
        ...where.AND,
        { status_not: 'PAUSED' },
        { status_not: 'DEMO' },
        { endDate_lt: attributionWindow },
      ];
    } else if (status === 'ATTRIBUTION') {
      where.AND = [
        { status_not: 'PAUSED' },
        { status_not: 'DEMO' },
        { endDate_gte: attributionWindow },
        { endDate_lte: currentDate },
        ...where.AND,
      ];
    } else if (status === 'LIVE') {
      where.AND = [
        { status_not: 'PAUSED' },
        { status_not: 'DEMO' },
        { endDate_gt: currentDate },
        ...where.AND,
      ];
    }
  }

  where.AND.push(...buildDateFilter(readDateFilterParams(params) || {}));

  return where;
};

export default buildAdvertiserWhere;
